import React from "react";
import ComboCard from "../pages/ComboCard"; // adjust path if needed

const ComboList = ({ combos = [], limit }) => {
  const displayedCombos = limit ? combos.slice(0, limit) : combos;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-8">
      {displayedCombos.map((combo) => (
        <ComboCard key={combo.id} combo={combo} />
      ))}
    </div>
  );
};

export default ComboList;
